
const digest = '6ab01738491677b7a2fd482e7a8148eeeb9e0be9b2a73b1669c46b860f9f2b8a';
const classes = {"buttons":"_buttons_1e87a_1","leftPart":"_leftPart_1e87a_9","text":"_text_1e87a_16","checkboxWrapper":"_checkboxWrapper_1e87a_27"};
const css = `._buttons_1e87a_1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 20px;
  margin-top: 30px;
  justify-content: space-between;
}
._buttons_1e87a_1 ._leftPart_1e87a_9 {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 20px;
}

._text_1e87a_16 {
  font-weight: 400;
  font-size: 14px;
}

hr {
  background: #eaedf4;
  width: 100%;
  margin-bottom: 20px;
}

._checkboxWrapper_1e87a_27 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  